import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'border-corner-pill', 'IconBorderCornerPill', [["path",{"d":"M4 20v-5c0 -6.075 4.925 -11 11 -11h5","key":"svg-0"}]]);